module.exports = __webpack_public_path__ + "static/media/app1.35c6710b.png";